+function ($,inbenta) { "use strict";

  var assistant = inbenta.Assistant;

  // Clicks
  $(document).on('click.clicable.data-api', '#inbenta-compagnon .clicable', function(e){
    var $this = $(this);

    // don't register click in accordion elements when they are closing.
    if( $this.attr('data-toggle') && !$this.hasClass('active') )
      return;

    assistant.click( $this.attr('data-click') , $this.attr('href') , $this.attr('target'), e );
  });

  // Ajax load
  $(document).on('click.ajaxLink', '#inbenta-compagnon .iaf-ajax, #inbenta-compagnon [iaf-ajax]', function(e){
    e.preventDefault();

    var $this = $(this),
      ajaxDiv = $this.attr('iaf-div') || '#inbenta-contents',
      $ajaxDiv = $(ajaxDiv),
      href = $this.attr('iaf-ajax') || $this.attr('href') || '';

    if(this.hasAttribute('iaf-ajax-once')){
      $this.removeAttr( "iaf-ajax" );
      $this.removeClass( "iaf-ajax" );
    }
    assistant.loadHtml({},
      $ajaxDiv,
      { url: href }
    );
  });

  // Search
  $(document).on('submit.search', '#inbenta-compagnon form.search-form', function(e){
    var $this = $(this),
        question = $this.find('.question-input').first().val(),
        isAjax = $this.hasClass('ajax-form'),
        div = $this.attr('iaf-div') || '#inbenta-contents';

    if( !assistant.search( question , isAjax, div ) ) {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // Rating
  $(document).on('inbenta.html.load ready', function(e){
    $('#inbenta-compagnon .inbenta-rating').inbentaRatingCompagnon();
  });

  // Do not allow empty comments in rating
  $(document).on('keyup.iaf-rating-comment', '#inbenta-compagnon .rating-comment [iaf-not-empty]', function(e){
    if($.trim($(this).val()).length > 0) {
      $(this).parents('.inbenta-rating').find($(this).attr('iaf-not-empty')).removeAttr('disabled');
    } else {
      $(this).parents('.inbenta-rating').find($(this).attr('iaf-not-empty')).attr('disabled', true);
    }
  });

  // Calendars
  if($.fn.pikaday){
    $(document).on( 'inbenta.html.load ready', function(e){
      $('input.datepicker').pikaday();
    });
  }

  // Instant Answers
  var instantAnswersManager = assistant.InstantAnswers;
  if (typeof instantAnswersManager != "undefined") {
    $(document).on( 'inbenta.html.load ready', function(e){
      instantAnswersManager.bindFields( $('#inbenta-compagnon .iaf-instant, [iaf-instant]') );
    });

    $(document).on('click.instant-clicable.data-api', '#inbenta-compagnon .instant-clicable', function(e){
      var $this = $(this);

      // don't register click in accordion elements when they are closing.
      if( $this.attr('data-toggle') && !$this.hasClass('active') )
        return;

      instantAnswersManager.instantClick( $this.attr('data-click'), $this.attr('data-inbentauq'), $this.attr('href') , $this.attr('target'), e );
    });
  }
}(window.jQuery,window.InbentaCompagnon);
